import { resolveDisplayLocale } from '~/utils/resolveDisplayLocale'
import { parseApiDateTime } from './parseApiDateTime'

const RELATIVE_TIME_DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'seconds' },
  { amount: 60, unit: 'minutes' },
  { amount: 24, unit: 'hours' },
  { amount: 7, unit: 'days' },
  { amount: 4.34524, unit: 'weeks' },
  { amount: 12, unit: 'months' },
  { amount: Number.POSITIVE_INFINITY, unit: 'years' }
]

export const formatRelativeTime = (
  value?: string | null,
  now: Date = new Date(),
  locale = 'en'
) => {
  const dateTime = parseApiDateTime(value)
  if (!dateTime) return ''

  const relativeTimeFormat = new Intl.RelativeTimeFormat(resolveDisplayLocale(locale), {
    numeric: 'auto'
  })
  let duration = (dateTime.toJSDate().getTime() - now.getTime()) / 1000

  for (const division of RELATIVE_TIME_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return relativeTimeFormat.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }

  return ''
}
